import Vue from 'vue'
import TurbolinksAdapter from 'vue-turbolinks'
import VueResource from 'vue-resource'

Vue.use(VueResource)

document.addEventListener('turbolinks:load', () => {
  Vue.http.headers.common['X-CSRF-Token'] = document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute('content')

  const el = document.querySelector('.vue-floating-notes')
  if (el) {
    new Vue({
      el,
      mixins: [TurbolinksAdapter],
      data: {
        isLoading: false,
        isOpen: false,
        adminToken: null,
        notes: ''
      },
      mounted() {
        const {form, textArea} = this.$refs
        const {adminToken, notes} = textArea.dataset
        if (adminToken) {
          this.adminToken = adminToken
        }
        if (notes && notes !== '') {
          this.notes = notes
        }

        form.onsubmit = e => {
          e.preventDefault()
          this.saveNotes()
          return false
        }
      },
      methods: {
        saveNotes() {
          const body = {
            question: {
              admin_token: this.adminToken,
              notes: this.notes
            }
          }
          this.isLoading = true
          this.$http.patch(this.$refs.form.action, body).then(
            response => {
              this.isLoading = false
            },
            response => {
              this.isLoading = false
            }
          )
        }
      }
    })
  }
})



// WEBPACK FOOTER //
// ./app/javascript/packs/components/floating_notes.js